import {useState} from 'react';

import {Button, SearchBar} from '@/components';
import {Input} from '@/components/common/Input';
import {Filter} from '@/components/Filter';

import type {UserFiltersProps} from './types';

const UserFilters = ({
  filtersToApply,
  clearFilters,
  selectAppliedFilters,
  handleApplyFilters,
  handleAutoComplete,
  isMerchant = false,
  dataCy,
  placeholder = 'Search Users',
}: UserFiltersProps) => {
  const [showFilters, setShowFilters] = useState<boolean>(false);

  const handleShowFilterChange = (): void => {
    setShowFilters(!showFilters);
  };

  const handleApplyFilter = (): void => {
    handleApplyFilters();
    setShowFilters(false);
  };

  const handleClearFilters = (): void => {
    setShowFilters(false);
    clearFilters();
  };

  return (
    <div className="mt-5 w-full">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Left Section: Search + Filters */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center sm:space-x-3 w-full sm:w-3/5 gap-3">
          {/* Search Bar */}
          <SearchBar
            handleSearch={handleAutoComplete}
            handleAutoComplete={handleAutoComplete}
            clearFilters={clearFilters}
            inputClassName="w-full sm:w-4/6"
            dataCy={dataCy}
            placeholder={placeholder}
          />

          {/* Filter Box */}
          {!isMerchant && (
            <div className="flex items-center space-x-3">
              <Filter
                closeFilter={() => setShowFilters(false)}
                handleShowFilter={handleShowFilterChange}
                label="Filters"
                bodyClassName="w-full md:w-[300px]"
                positionLeft={1}
              >
                {/* Filter Body */}
                {showFilters && (
                  <div className="p-2 space-y-4 max-w-4xl mx-auto w-full col-span-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="flex items-center gap-2 col-span-full w-full">
                        <Input
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            selectAppliedFilters(
                              'bankAccountNumber',
                              e.target.value,
                            )
                          }
                          name="bankAccountNumber"
                          label="Bank Account No."
                          type="text"
                          value={filtersToApply.bankAccountNumber || ''}
                          className="w-full"
                          placeholder="Enter Bank Account No."
                        />
                      </div>
                    </div>

                    <div className="flex justify-start flex-wrap gap-2">
                      <Button
                        onClick={handleClearFilters}
                        colorScheme="cyan"
                        variant="ghost"
                      >
                        Clear
                      </Button>

                      <Button onClick={handleApplyFilter} colorScheme="cyan">
                        Apply Filters
                      </Button>
                    </div>
                  </div>
                )}
              </Filter>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserFilters;
